module.exports = __webpack_public_path__ + "img/alex_myprofile.a4091e93.svg";